import React, { useState } from "react";
import { TableRow, TableCell } from "@mui/material";
import IosSwitchBtn from "../../../../Component/DigitalMarketing/IosSwitchbtn";
import eye from "../../../../assets/DigitalMarketing/image/visibility.svg";
 
interface TableListsProps {
  searchValue: string;
  TestPackageData: {
    data: Array<{
      id: number;
      packageName: string;
      lab?: { labName: string };
      price: number;
      discount: number;
      validityPeriod: string;
      activeStatus: number;
      TestPackageServices?: Array<{
        id: number;
        serviceName: string;
      }>;
    }>;
  };
  setShow: (show: boolean) => void;
  setUpdateData: (data: any) => void;
  setView: (view: boolean) => void;
}
 
const TableLists: React.FC<TableListsProps> = ({
  TestPackageData,
  setShow,
  setUpdateData,
  setView,
searchValue, }) => {
  // State to manage the active status switches
  const [checkedStates, setCheckedStates] = useState<boolean[]>(
    TestPackageData?.data?.map((data) => data.activeStatus === 1) || []
  );
 
  const handleChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event.target.checked;
    setCheckedStates(newCheckedStates);
  };
 
  const handleView = (data: any) => {
    setUpdateData(data); // Set the selected row's data
    setView(true); // Enable view mode
    setShow(true); // Open the ViewTestPackages component
  };
 
  if (!TestPackageData || TestPackageData.data.length === 0) {
    return <div>No data available</div>;
  }
 
  return (
    <>
      {TestPackageData?.data?.map((row, index) => (
        <TableRow key={row.id}>
          <TableCell align="left">{index + 1}</TableCell>
          <TableCell align="left">{row.packageName}</TableCell>
          <TableCell align="left">{row.lab?.labName || "N/A"}</TableCell>
          <TableCell align="left">{row.price.toFixed(2)}</TableCell>
          <TableCell align="left">{row.discount}%</TableCell>
          <TableCell align="left">{row.validityPeriod}</TableCell>
          <TableCell align="left">
            <IosSwitchBtn
              checked={checkedStates[index]}
              label={checkedStates[index] ? "Active" : "Inactive"}
              onChange={handleChange(index)}
            />
          </TableCell>
          {/* <TableCell align="left">
            <img
              src={eye}
              alt="View"
              className="blue-c action-icon cursor"
              onClick={() => handleView(row)}
            />
          </TableCell> */}
        </TableRow>
      ))}
    </>
  );
};
 
export default TableLists;